import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AppsSharedModule, BaseSharedModule } from 'base';
import { BaseCustomerEmployeeMasterDataTabComponent } from './_components/employee-master-data-tab/base-customer-employee-master-data-tab.component';
import { BaseCustomerEmployeeOperationInfoTabComponent } from './_components/employee-operation-info-tab/base-customer-employee-operation-info-tab.component';
import { BaseCustomerEmployeeReviewsTabComponent } from './_components/employee-reviews-tab/base-customer-employee-reviews-tab.component';
import { BaseCustomerEmployeeTimeRecordingsTabComponent } from './_components/employee-time-recordings-tab/base-customer-employee-time-recordings-tab.component';
import { BaseCustomerEmployeeTimeRecordingsListItemComponent } from './_components/employee-time-recordings-tab/employee-time-recordings-list-item/base-customer-employee-time-recordings-list-item.component';
import { BaseCustomerShiftReadinessComponent } from './_components/shift-readiness/base-customer-shift-readiness.component';
import { BaseCustomerStaffRequestModalComponent } from './_components/staff-request-modal/base-customer-staff-request-modal.component';
import { BaseCustomerCandidateDocumentComponent } from './_components/employee-documents-tab/base-customer-candidate-document/base-customer-candidate-document.component';
import { BaseCustomerEmployeeDocumentsTabComponent } from './_components/employee-documents-tab/base-customer-employee-documents-tab.component';
import { BaseCustomerEmployeeWorkCouncilTabComponent } from './_components/employee-work-council-tab/base-customer-employee-work-council-tab.component';
import { BaseCustomerChangeStatusConfirmationModalComponent } from './_components/employee-work-council-tab/change-status-confirmation-modal/base-customer-change-status-confirmation-modal.component';
import { BaseCustomerWorkCouncilCommentsComponent } from './_components/employee-work-council-tab/work-council-comments/base-customer-work-council-comments.component';
import { BaseCustomerWorkCouncilCommentComponent } from './_components/employee-work-council-tab/work-council-comment/base-customer-work-council-comment.component';
import { BaseCustomerOfferActionsService } from './_services/base-customer-offer-actions.service';
import { BaseCustomerWorkCouncilStatusButtonsComponent } from './_components/employee-work-council-tab/work-council-offer-status-buttons/base-customer-work-council-status-buttons.component';
import { BaseCustomerEditShiftTimesModalComponent } from './_components/edit-shift-times-modal/base-customer-edit-shift-times-modal.component';
import { BaseCustomerWeekdaysAndShiftsComponent } from './_components/weekdays-and-shifts/base-customer-weekdays-and-shifts.component';
import { BaseCustomerIZSWidgetComponent } from './_components/izs-widget/izs-widget.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    TranslateModule,
    BaseSharedModule,
    AppsSharedModule,
  ],
  declarations: [
    BaseCustomerStaffRequestModalComponent,
    BaseCustomerShiftReadinessComponent,
    BaseCustomerEmployeeMasterDataTabComponent,
    BaseCustomerEmployeeOperationInfoTabComponent,
    BaseCustomerEmployeeReviewsTabComponent,
    BaseCustomerEmployeeTimeRecordingsTabComponent,
    BaseCustomerEmployeeTimeRecordingsListItemComponent,
    BaseCustomerCandidateDocumentComponent,
    BaseCustomerEmployeeDocumentsTabComponent,
    BaseCustomerEmployeeWorkCouncilTabComponent,
    BaseCustomerChangeStatusConfirmationModalComponent,
    BaseCustomerWorkCouncilCommentsComponent,
    BaseCustomerWorkCouncilCommentComponent,
    BaseCustomerWorkCouncilStatusButtonsComponent,
    BaseCustomerEditShiftTimesModalComponent,
    BaseCustomerWeekdaysAndShiftsComponent,
    BaseCustomerIZSWidgetComponent,
  ],
  exports: [
    BaseCustomerStaffRequestModalComponent,
    BaseCustomerShiftReadinessComponent,
    BaseCustomerEmployeeMasterDataTabComponent,
    BaseCustomerEmployeeOperationInfoTabComponent,
    BaseCustomerEmployeeReviewsTabComponent,
    BaseCustomerEmployeeTimeRecordingsTabComponent,
    BaseCustomerEmployeeTimeRecordingsListItemComponent,
    BaseCustomerCandidateDocumentComponent,
    BaseCustomerEmployeeDocumentsTabComponent,
    BaseCustomerEmployeeWorkCouncilTabComponent,
    BaseCustomerChangeStatusConfirmationModalComponent,
    BaseCustomerWorkCouncilCommentsComponent,
    BaseCustomerWorkCouncilCommentComponent,
    BaseCustomerWorkCouncilStatusButtonsComponent,
    BaseCustomerEditShiftTimesModalComponent,
    BaseCustomerWeekdaysAndShiftsComponent,
    BaseCustomerIZSWidgetComponent,
  ],
  providers: [BaseCustomerOfferActionsService],
})
export class BaseCustomerSharedModule {}
